export default __webpack_public_path__ + "static/media/agote4_c.011d171c.jpg";